import { render, staticRenderFns } from "./ChartCard.component.vue?vue&type=template&id=05f40828&"
import script from "./ChartCard.component.ts?vue&type=script&lang=js&"
export * from "./ChartCard.component.ts?vue&type=script&lang=js&"
import style0 from "./ChartCard.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports